module.exports = __webpack_public_path__ + "static/media/roof-8-steadmans.01c7208d.jpg";